import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_RESUL_EVAL;

export default {
  update(payload) {
    return baseApi.put(resource, payload);
  },
};
